import { Link, useNavigate } from "@tanstack/react-router";
import { type ComponentProps, useCallback } from "react";
import type { RouteTarget } from "./registry/nav";

/** A link to a route target built by a feature's paths module (params and search included). */
export function RouteLink({
  to,
  ...props
}: { to: RouteTarget } & Omit<ComponentProps<"a">, "href" | "target">) {
  return <Link to={to.to} params={to.params as never} search={to.search as never} {...props} />;
}

/** Navigates to a route target; `replace` keeps the history entry count. */
export function useGo() {
  const navigate = useNavigate();
  return useCallback(
    (target: RouteTarget, replace = false) =>
      void navigate({ ...(target as never as object), replace } as never),
    [navigate],
  );
}
